var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThought(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 21C22 21.5523 21.5523 22 21 22C20.4477 22 20 21.5523 20 21C20 20.4477 20.4477 20 21 20C21.5523 20 22 20.4477 22 21Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 17C20 18.1046 19.1046 19 18 19C16.8954 19 16 18.1046 16 17C16 15.8954 16.8954 15 18 15C19.1046 15 20 15.8954 20 17Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.5C2 6.31803 2.28063 7.0705 2.75088 7.66641C2.27833 8.32321 2 9.1291 2 10C2 12.2091 3.79086 14 6 14C6.17493 14 6.34724 13.9888 6.51624 13.967C7.20304 15.1808 8.50585 16 10 16C11.524 16 12.8489 15.1478 13.5241 13.8939C13.8383 13.9634 14.1649 14 14.5 14C16.9853 14 19 11.9853 19 9.5C19 8.32481 18.5495 7.25483 17.8118 6.45334C17.9331 6.15954 18 5.83759 18 5.5C18 4.11929 16.8807 3 15.5 3C14.9713 3 14.481 3.16411 14.0771 3.44416C13.3434 2.56177 12.2373 2 11 2C9.87963 2 8.86685 2.46061 8.14069 3.2028C7.49903 2.46582 6.55391 2 5.5 2C3.567 2 2 3.567 2 5.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThought);
export default __webpack_public_path__ + "static/media/thought.92e92871e77619bcf96b184d7f016e59.svg";
export { ForwardRef as ReactComponent };